import { forwardRef, type HTMLAttributes } from 'react'

export const SpaceImagesContainer = forwardRef<
	HTMLDivElement,
	HTMLAttributes<HTMLDivElement> & { $gap?: number }
>(({ $gap = 0, className, style, ...props }, ref) => (
	<div
		className={`my-3 grid w-full grid-cols-4 max-xl:grid-cols-2 max-m:grid-cols-1 ${className ?? ''}`}
		ref={ref}
		style={{ gap: $gap ? `${$gap * 4}px` : undefined, ...style }}
		{...props}
	/>
))

interface SpaceImageFrameProps extends HTMLAttributes<HTMLDivElement> {
	$isSelected: boolean
}

export const SpaceImageFrame = forwardRef<HTMLDivElement, SpaceImageFrameProps>(
	({ $isSelected, className, ...props }, ref) => (
		<div
			className={`[&>div]:h-full [&>div]:justify-start [&>div]:rounded-xl [&>div]:p-3 [&>div]:focus-within:bg-[unset] ${
				$isSelected
					? '[&>div]:shadow-[0_0_0_4px_var(--color-neutral-700)] [&>div]:focus-within:shadow-[0_0_0_4px_var(--color-neutral-700)]'
					: '[&>div]:shadow-[unset] [&>div]:focus-within:shadow-[unset]'
			} ${className ?? ''}`}
			ref={ref}
			{...props}
		/>
	)
)

export const SpaceImageSelectionInfo = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => (
	<div
		className={`flex min-h-[68px] w-full flex-col [&_h4]:overflow-hidden [&_h4]:text-ellipsis [&_h4]:whitespace-nowrap [&_h4]:font-medium [&_h4]:text-neutral-900 [&_h4]:text-sm ${className ?? ''}`}
		{...props}
	/>
)
